/**
*
* RedAgenda
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import setLanguageContent from 'helpers/setLanguageContent';
import cloneDeep from 'helpers/cloneDeep';
import setCssMediaQuery from 'helpers/setCssMediaQuery';
import throttle from 'helpers/throttle';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import TemplateFilterSwitch from 'components/TemplateFilterSwitch';

import {
  sortByDate,
} from './helpers';

import RedAgendaPresentation from './RedAgendaPresentation';

import defaultTextValues from './defaultTextValues';


class RedAgenda extends React.Component {

  constructor() {
    super();

    this._isMounted = false;

    this.allDaysContainer = React.createRef();

    this.handleShowPresentation = this.handleShowPresentation.bind(this);
    this.handleDropdownDaySelection = this.handleDropdownDaySelection.bind(this);
    this.isDraggableCallback = this.isDraggableCallback.bind(this);
    this.scrollTitles = this.scrollTitles.bind(this);
    this.setSelectedFilter = this.setSelectedFilter.bind(this);
    this.handleIsTagActive = this.handleIsTagActive.bind(this);

    this.state = {
      presentationData: '',
      chosenDay: 0,
      top: '50vh',
      canDrag: false,
      hasScroll: false,
      availableTags: [],
      selectedTagsFilter: [],
    };
  }

  scrollTitles = throttle(() => {

    if (!this._isMounted) return;

    const {
      commonData
    } = this.props;
  
    const {
      sectionId
    } = commonData;

    const agendaContent = document.querySelector(`[data-stylereference="${sectionId}-contentAgenda"]`);
    const trackTitles = document.querySelectorAll(`[data-stylereference="${sectionId}-trackTitle"]`);

    const trackTitleStyles = setCssMediaQuery(this.props.styling, 'trackTitle', this.props.viewPort)

    const topStringPosition = trackTitleStyles.indexOf(';top: ');
    const firstSemicolonStringPosition = trackTitleStyles.indexOf(';', topStringPosition + 1);

    const originalTopValue = trackTitleStyles.substring(topStringPosition + 6, firstSemicolonStringPosition);

    trackTitles.forEach((trackTitle) => {

      if (trackTitle.style && agendaContent.getBoundingClientRect().top <= 0) {

        trackTitle.style['top'] = window.scrollY + window.innerHeight + Math.abs(agendaContent.getBoundingClientRect().top) - trackTitle.offsetHeight + 'px';
      } else {
        trackTitle.style['top'] = originalTopValue;
      }
    })
  }, 1);


  isDraggableCallback(value) {
    if (this._isMounted) this.setState({
      canDrag: value
    });
  }

  handleShowPresentation(payload) {
    if (this._isMounted) this.setState({
      presentationData: payload,
      top: `${document.querySelector(this.props.viewRef).scrollTop + (window.innerHeight / 4)}px`
    });
  }

  handleDropdownDaySelection(day) {
    if (this._isMounted) this.setState({
      chosenDay: day
    }, () => {
      setTimeout(() => {
        if (this.allDaysContainer.current) this.allDaysContainer.current.scrollIntoView(true);
      }, 300);
    });
  }


  setSelectedFilter(filter, type) {
    const newFilters = this.state[`selected${type}Filter`];

    if (newFilters.includes(filter)) {
      const index = newFilters.indexOf(filter);
      newFilters.splice(index, 1);
      return this.setState({
        [`selected${type}Filter`]: newFilters
      });
    }

    newFilters.push(filter);
    return this.setState({
      [`selected${type}Filter`]: newFilters
    });


  }

  handleIsTagActive(tagId, remove) {

    const {
      selectedTagsFilter
    } = this.state



    if (selectedTagsFilter.includes(tagId) || remove) {
      this.setState(prevState => {
        let newSelectedTags = cloneDeep(prevState.selectedTagsFilter);
        newSelectedTags = newSelectedTags.filter(tag => tag !== tagId);

        return {
          selectedTagsFilter: newSelectedTags
        };
      })
    }

    if (!selectedTagsFilter.includes(tagId) && !remove) {
      this.setState(prevState => {
        const newSelectedTags = cloneDeep(prevState.selectedTagsFilter);
        newSelectedTags.push(tagId)

        return {
          selectedTagsFilter: newSelectedTags
        };
      })
    }

  }

  componentDidMount() {

    this._isMounted = true;

    const {
      commonProps,
      commonData,
      viewRef
    } = this.props;

    const {
      componentPayload
    } = commonData;

    const { 
      availableTags
    } = componentPayload;

    const {
      isEditor,
      isPreview,
      frameRef
    } = commonProps;

    this.setState({
      availableTags: availableTags
    });

    if (this.props.viewRef && document.querySelector(viewRef) && !this.state.hasScroll) {

      const getParentNode = isEditor ? document.querySelector(frameRef).contentWindow : isPreview ? document.querySelector(viewRef).parentNode.parentNode.parentNode : document.querySelector(viewRef);
      const getFrame = frameRef && document.querySelector(frameRef) ? document.querySelector(frameRef).contentWindow : getParentNode;

      this.setState({
        hasScroll: true
      }, getFrame.addEventListener('scroll', this.scrollTitles))
    }


  }

  

  componentDidUpdate() {

    const {
      commonProps,
      viewRef
    } = this.props;

    const {
      isEditor,
      isPreview,
      frameRef
    } = commonProps;

    if (viewRef && document.querySelector(viewRef) && !this.state.hasScroll) {

      const getParentNode = isEditor ? document.querySelector(frameRef).contentWindow : isPreview ? document.querySelector(viewRef).parentNode.parentNode.parentNode : document.querySelector(viewRef);
      const getFrame = frameRef && document.querySelector(frameRef) ? document.querySelector(frameRef).contentWindow : getParentNode;

      this.setState({
        hasScroll: true
      }, getFrame.addEventListener('scroll', this.scrollTitles))
    }

  }

  componentWillUnmount() {

    this._isMounted = false;

    const {
      commonProps,
      viewRef
    } = this.props;

    const {
      isEditor,
      isPreview,
      frameRef
    } = commonProps;

    if (this.props.viewRef && document.querySelector(viewRef) && this.state.hasScroll) {

      const getParentNode = isEditor ? document.querySelector(frameRef).contentWindow : isPreview ? document.querySelector(viewRef).parentNode.parentNode.parentNode : document.querySelector(viewRef);
      const getFrame = frameRef && document.querySelector(frameRef) ? document.querySelector(frameRef).contentWindow : getParentNode;

      getFrame.removeEventListener('scroll', this.scrollTitles);
    }

  }


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      agendaData,
      isMiniagenda,
      isEditor,
      companies,
      viewPort
    } = this.props;

    const {
      customStyles
    } = commonData;

    const {
      componentPayload
    } = commonData;

    const {
      enableFilters
    } = componentPayload;

    const {
      timezone,
      pages,
      language
    } = commonProps;

    const {
      presentations,
      agenda
    } = agendaData;


    const {
      chosenDay,
      presentationData,
      top,
      canDrag,
      availableTags,
      selectedTagsFilter,
    } = this.state;
    

    const filteredAvailableTags = availableTags ? availableTags.filter(tag => presentations.reduce((acc, presentation) => acc = presentation?.tags ? [...acc, ...presentation.tags] : [...acc], []).includes(tag.tagId)) : '';

    const selectedFilters = {
      Tags: selectedTagsFilter.length ? selectedTagsFilter : []
    };

    const availableFilters = {
      Tags: filteredAvailableTags || []
    };

    const activeFiltersNumber = Object.keys(selectedFilters).reduce((acc, key) => acc + selectedFilters[key].length, 0);




    const utcHoursOffset = moment().tz(timezone).utcOffset() / 60;
    const offsetString = `GMT ${utcHoursOffset > -1 ? '+' : ''}${utcHoursOffset}`;

    const agendaPageId = pages.find(page => {
      if (page.slug === 'agenda') {
        return page.pageId;
      }
    });

    const agendaSorted = agenda.sort(function (a, b) {
      return a.dayDate - b.dayDate;
    });

    const dayTabs = agendaSorted ? agendaSorted.map((thisAgendaTelement, b) => {
      const handleTabSwitch = () => {

        this.setState({
          chosenDay: b
        }, () => {
          setTimeout(() => {
            if (this.allDaysContainer.current) this.allDaysContainer.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
          }, 300);
        });

      };

      return (
        <Wrapper
          {...commonProps}
          key={`RedAgenda-dayTab-${b}`}

          typeOfStyle={this.state.chosenDay === b ? 'dayTabActive' : 'dayTab'}
          handleClick={handleTabSwitch}
          editorData={
            {
              editorType: this.state.chosenDay === b ? 'dayTabActive' : 'dayTab',
              ...commonData
            }
          }
          active={this.state.chosenDay === b} // ? Not sure how to handle state of this tab
        >
          {thisAgendaTelement && thisAgendaTelement.title ? setLanguageContent(thisAgendaTelement, 'title', language) : thisAgendaTelement.dayDate ? moment(thisAgendaTelement.dayDate).tz(timezone).format('MMMM DD') : ''}
        </Wrapper>
      );

    }) : '';

    const dayDropdownOptions = agendaSorted ? agendaSorted.map((option, b) => {

      return {
        title: option && option.title ? setLanguageContent(option, 'title', language) : option.dayDate ? moment(option.dayDate).tz(timezone).format('Do MMMM') : '',
        value: b
      }
    }) : '';


    const thisAgenda = agendaSorted[chosenDay];


    const allPresentations = [];
    const allPresentationsTimes = [];

    const tracks = thisAgenda && thisAgenda.tracks ? thisAgenda.tracks.map((track, i) => {

      const thisTrack = cloneDeep(track);
      const presentationsTrackCount = {};

      if (!thisTrack.presentations) return thisTrack;

      const trackTitle = setLanguageContent(thisTrack, 'title', language);

      const mapPresentations = thisTrack.presentations.map((trackPresentation) => {
        let thisPresentationData;
        if (presentations && presentations.length) {
          for (let c = 0; c < presentations.length; c++) {
            if (presentations[c].presentationId === trackPresentation.presentationId) {

              if (presentations[c].isHidden) return;

              const thisPresentation = cloneDeep(presentations[c]);

              const start = moment(thisPresentation.dateFrom).tz(timezone);
              const end = moment(thisPresentation.dateTo).tz(timezone);

              const isNextDay = !start.isSame(end, 'day');

              let diff = isNextDay ? moment(thisPresentation.dateFrom).tz(timezone).endOf('day').diff(start) : end.diff(start);

              diff = moment.utc(diff);
              diff = parseInt((diff.format('HH') * 60)) + parseInt(diff.format('mm'));
              let diffMinutes = diff;

              const thisPresentationHour = start.format('HH');
              let thisPresentationMinutes = start.format('mm');

              let thisPresentationHourEnd = end.format('HH');
              let thisPresentationMinutesEnd = end.format('mm');


              if (isNextDay) {
                thisPresentationHourEnd = '24';
                thisPresentationMinutesEnd = '00';
              }

              if (diff == 0) diffMinutes = thisPresentationMinutesEnd - thisPresentationMinutes;

              thisPresentation.startHour = thisPresentationHour;
              thisPresentation.startMinutes = thisPresentationMinutes;
              thisPresentation.endHour = thisPresentationHourEnd;
              thisPresentation.endMinutes = thisPresentationMinutesEnd;
              thisPresentation.diff = diff;
              thisPresentation.diffMinutes = diffMinutes;

              thisPresentationMinutes = Number(thisPresentationMinutes);

              thisPresentationMinutes = thisPresentationMinutes >= 30 ? '30' : '00';

              const trackCountKey = thisPresentationHour + thisPresentationMinutes;

              presentationsTrackCount[trackCountKey] = presentationsTrackCount[trackCountKey] ? presentationsTrackCount[trackCountKey] + 1 : 1;
              thisPresentation.rowNumber = presentationsTrackCount[trackCountKey];
              thisPresentation.trackKey = trackCountKey;

              thisPresentation.trackTitle = trackTitle;

              allPresentations.push(thisPresentation);
              allPresentationsTimes.push(trackCountKey);
              thisPresentationData = thisPresentation;
              break;
            }
          }
        }
        return thisPresentationData;
      });

      thisTrack.trackCount = presentationsTrackCount;

      const sortPresentations = mapPresentations.sort(sortByDate);
      thisTrack.presentations = sortPresentations;

      return thisTrack;
    }) : '';

    const allSortedDayPresentations = allPresentations.sort(sortByDate);


    const rulerBlocksArray = [];
    let agendaContent;


    if (allSortedDayPresentations && allSortedDayPresentations.length > 0) {
      const firstPresentationHour = Number(moment(allSortedDayPresentations[0].dateFrom).tz(timezone).format('HH'));
      const lastPresentationHour = Number(moment(allSortedDayPresentations[allSortedDayPresentations.length - 1].dateTo).tz(timezone).format('HH'));

      const isNextDay = [];

      const allLastHours = allSortedDayPresentations.map(presentation => {
        const thisDay = moment(presentation.dateFrom).tz(timezone).format('DD');
        const thisDayNext = moment(presentation.dateTo).tz(timezone).format('DD');
        if (!isNextDay.includes(thisDay) && thisDayNext !== thisDayNext) isNextDay.push(thisDay);
        return presentation.endHour;
      })

      const getFirstHour = isMiniagenda ? firstPresentationHour : firstPresentationHour;

      const getFirstHourWithMinutes = Number(moment(allSortedDayPresentations[0].dateFrom).tz(timezone).format('mm'));

      let getLastHour = Math.max(...allLastHours);

      if (isMiniagenda && lastPresentationHour < getLastHour + 3) getLastHour = lastPresentationHour;
      if (isMiniagenda && (lastPresentationHour - getFirstHour) > 3) getLastHour = getFirstHour + 3;


      let tracksLength = 0;

      if (tracks && tracks.length) {
        for (let index = 0; index < tracks.length; index++) {
          const element = tracks[index];
          if (element && element.presentations && element.presentations.length > 0) {
            tracksLength = tracksLength + 1;
          }
        }
      }

      const tracksContent = tracks ? tracks.map((track, i) => {

        const filteredPresentations = selectedTagsFilter.length && track && track.presentations ? track.presentations.sort(sortByDate).filter(presentation => {


          let isFiltered = false;

          if(!presentation) return isFiltered;

          for (const filterKey in selectedFilters) {

            if (selectedFilters[filterKey].length) {

              const lowercaseKey = filterKey.toLowerCase();
              if (Array.isArray(presentation[lowercaseKey])) {
                const intersection = presentation[lowercaseKey].filter(value => selectedFilters[filterKey].includes(value));

                if (!intersection.length) {
                  isFiltered = false;
                  break;
                }
                isFiltered = true;
              }
            }
          }

          return isFiltered;

        }) : track && track.presentations ? track.presentations.sort(sortByDate) : null;


        const presentationsContent = filteredPresentations && filteredPresentations.map((presentation, index) => {

          if (!presentation) return;

          const { presentationId } = presentation;

          return (
            <RedAgendaPresentation
              {...this.props}
              firstHour={getFirstHour}
              firstHourMinutes={getFirstHourWithMinutes}
              presentation={presentation}
              trackCount={track.trackCount}
              isTrackEven={i === 0 || i % 2 === 0 ? true : false}
              index={index}
              blurredTop={isMiniagenda && moment(presentation.dateFrom).tz(timezone).format('HH') < getFirstHour}
              blurredBottom={isMiniagenda && moment(presentation.dateTo).tz(timezone).format('HH') > getLastHour}
              handleShowPresentation={this.handleShowPresentation}
              key={`RedAgendaPresentation-${presentationId}`}
              companies={companies}
              offsetString={offsetString}
              tracksLength={tracksLength}
              availableTags={filteredAvailableTags}
              handleIsTagActive={this.handleIsTagActive}
            />
          );
        });


        const trackTitle = setLanguageContent(track, 'title', language);

        if (presentationsContent && presentationsContent.length > 0) {



          const trackTitleWrapper = (<Wrapper
            {...commonProps}

            typeOfStyle={'trackTitle'}
            editorData={
              {
                editorType: 'trackTitle',
                ...commonData
              }
            }
          >
            {trackTitle ? trackTitle : <span>&nbsp;</span>}
          </Wrapper>)

          return (
            <Wrapper
              {...commonProps}
              key={`trackWrapper-${i}`}

              typeOfStyle={'trackWrapper'}
              editorData={
                {
                  editorType: 'trackWrapper',
                  ...commonData
                }
              }
            >
              {trackTitleWrapper}
              {presentationsContent}
            </Wrapper>
          );
        }

        return '';
      }) : '';

      const lastHourWithMidnight = getLastHour && isNextDay.length <= 1 ? getLastHour : 24 + getLastHour;
      const rulerLength = getLastHour == 24 ? lastHourWithMidnight - getFirstHour : lastHourWithMidnight - getFirstHour + 1;

      for (let i = 0; i < rulerLength; i++) {

        let thisRulerHourContent = getFirstHour + i === 24 ? '00' : getFirstHour + i;
        thisRulerHourContent = thisRulerHourContent.toString();
        if (getFirstHour + i < 10) thisRulerHourContent = 0 + thisRulerHourContent;

        if (thisRulerHourContent > 24) thisRulerHourContent = thisRulerHourContent - 24;


        rulerBlocksArray.push(
          <Wrapper
            {...commonProps}
            key={`RedAgendaRulerBlockHours-${thisRulerHourContent + allSortedDayPresentations[0].dateFrom}`}

            typeOfStyle={'rulerBlock'}
            editorData={
              {
                editorType: 'rulerBlock',
                ...commonData
              }
            }
          >
            {`${thisRulerHourContent}:00`}
          </Wrapper>
        );

        rulerBlocksArray.push(
          <Wrapper
            {...commonProps}
            key={`RedAgendaRulerBlockMinutes-${thisRulerHourContent + allSortedDayPresentations[0].dateFrom}`}

            typeOfStyle={'rulerBlock'}
            editorData={
              {
                editorType: 'rulerBlock',
                ...commonData
              }
            }
          >
            {`${thisRulerHourContent}:30`}
          </Wrapper>
        );
      }

      agendaContent = (
        <Wrapper
          {...commonProps}

          typeOfStyle={'dayContainer'}
          editorData={
            {
              editorType: 'dayContainer',
              ...commonData
            }
          }
        >

          <Wrapper
            {...commonProps}

            typeOfStyle={'dayAllTracksContainer'}
            canDrag={canDrag}
            isDraggableCallback={this.isDraggableCallback}
            isDraggable={true}
            editorData={
              {
                editorType: 'dayAllTracksContainer',
                ...commonData
              }
            }
          >
            {tracksContent}
          </Wrapper>
        </Wrapper>
      );

    }


    const singlePresentationContent = presentationData ? (
      <RedAgendaPresentation
        {...this.props}
        allSortedDayPresentations={allSortedDayPresentations}
        presentation={presentationData}
        isSingle={true}
        handleShowPresentation={this.handleShowPresentation}
        top={top}
        offsetString={offsetString}
        availableTags={filteredAvailableTags}
        handleIsTagActive={this.handleIsTagActive}
      />
    ) : '';

    const dayDropdown = (
      <Wrapper
        {...commonProps}

        typeOfStyle={'dayDropdown'}
        type={'select'}
        selectValue={thisAgenda && thisAgenda.title ? setLanguageContent(thisAgenda, 'title', language) : thisAgenda.dayDate ? moment(thisAgenda.dayDate).tz(timezone).format('Do MMMM') : ''}
        selectData={{
          options: dayDropdownOptions,
          dropdownItemStyles: { fontSize: '1.8rem', },
          selectedStyles: { fontSize: '1.8rem', }
        }}
        handleSelectChange={this.handleDropdownDaySelection}
        editorData={
          {
            editorType: 'dayDropdown',
            ...commonData
          }
        }
      />
    );

    return (
      <Wrapper
        {...commonProps}

        typeOfStyle={'wrapper'}
        innerRef={this.allDaysContainer}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >

        <Wrapper
          {...commonProps}

          typeOfStyle={'sectionTitle'}
          defaultValues={defaultTextValues}
          type={'text'}
          editorData={
            {
              editorType: 'sectionTitle',
              ...commonData
            }
          }
        />

        <Wrapper
          {...commonProps}

          typeOfStyle={'mainInnerWrapper'}
          editorData={
            {
              editorType: 'mainInnerWrapper',
              ...commonData
            }
          }
          
        >
          <TemplateFilterSwitch
            activeFiltersNumber={activeFiltersNumber}
            handleFilterClick={this.setSelectedFilter}
            availableFilters={availableFilters}
            selectedFilters={selectedFilters}
            enableFilters={enableFilters}
            commonProps={commonProps}
            typeOfStyle={'templateTagWrapper'}
            customStyles={customStyles}
          />
          <Wrapper
            {...commonProps}

            typeOfStyle={'topOptionsWrapper'}
            editorData={
              {
                editorType: 'topOptionsWrapper',
                ...commonData
              }
            }
          >
            {dayTabs}
            {dayDropdown}
          </Wrapper>
          <Wrapper
            {...commonProps}

            typeOfStyle={'timeAndContentWrapper'}
            editorData={
              {
                editorType: 'timeAndContentWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}

              typeOfStyle={'timeRulerWrapper'}
              editorData={
                {
                  editorType: 'timeRulerWrapper',
                  ...commonData
                }
              }
            >
              {/*  part below can be conditionally rendered when event is of type 'online' */}
              <Wrapper
                {...commonProps}

                typeOfStyle={'timeOffsetWrapper'}
                editorData={
                  {
                    editorType: 'timeOffsetWrapper',
                    ...commonData
                  }
                }
              >
                {offsetString}
              </Wrapper>
              {rulerBlocksArray}
            </Wrapper>
            {agendaContent ? (
              <Wrapper
                {...commonProps}

                typeOfStyle={'contentAgenda'}
                editorData={
                  {
                    editorType: 'contentAgenda',
                    ...commonData
                  }
                }
              >
                {agendaContent}
                {
                  canDrag ? (
                    <Wrapper
                      {...commonProps}

                      typeOfStyle={'swipe'}
                      editorData={
                        {
                          editorType: 'swipe',
                          ...commonData
                        }
                      }
                    />
                  ) : ''
                }
              </Wrapper>
            ) : (
              <Wrapper
                {...commonProps}

                typeOfStyle={'missingAgenda'}
                editorData={
                  {
                    editorType: 'missingAgenda',
                    ...commonData
                  }
                }
              >
                Agenda coming soon...
              </Wrapper>
            )}
          </Wrapper>

        </Wrapper>
        {isMiniagenda ? (
          <Wrapper
            {...commonProps}

            typeOfStyle={'fullAgendaLink'}
            defaultUrl={agendaPageId ? '/agenda' : ''}
            as={isEditor ? 'div' : 'a'}
            type={'text'}
            target={'_self'}
            defaultValues={defaultTextValues}
            editorData={
              {
                editorType: 'fullAgendaLink',
                ...commonData
              }
            }
          />
        ) : ''}
        {singlePresentationContent}
      </Wrapper>
    );
  }
}

RedAgenda.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  agendaData: PropTypes.object,
  isMiniagenda: PropTypes.bool,
  isEditor: PropTypes.bool,
  companies: PropTypes.array
};

export default RedAgenda;
